import { TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { Severity, Status } from "src/app/inventory/constants/constants";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { CurrencyService } from "src/app/modules/shared/services/currency.service";
import { SharedChannelService } from "src/app/modules/shared/services/channel.service";
import { AccountModuleId } from "src/app/modules/shared/constants/modules.constant";
import { ChannelN } from "src/app/modules/shared/models/channel.model";
import { Subject, lastValueFrom, takeUntil } from "rxjs";
import { FinanceService } from "src/app/finance/finance.service";
import { IDeposit, IDepositDetail } from "src/app/finance/models/deposit.model";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { ImportserialService } from "../../services/importserial.service";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";

@Component({
    selector: "app-make-deposit",
    templateUrl: "./make-deposit.component.html",
    styleUrls: ["./make-deposit.component.scss"],
})
export class MakeDepositComponent implements OnInit, OnChanges, OnDestroy {
    @Input() display;
    @Input() selectedFinance;
    @Input() depositId;
    @Input() type;
    @Input() isShowVoidDelete : boolean = true;
    @Input() isEditableViewDialog : boolean = true;
    @Output() close = new EventEmitter();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    concatednatedPaymentsTb: any = [];
    allPaymentsTb: any = [];
    depositHeader: string = "Make Deposit";

    banks = [];
    selectedBank;
    paymentsTB = [];
    totalAmt = 0;
    defaultMemo = "Deposit";

    displayDetails = false;
    payTo = "customer";
    allVendors: any[] = [];
    allVendorsDD: any[] = [];
    selectedVendor;
    vendorDetails;
    accountChannels = [];
    selectedChannel = null;
    allAccountsDD = [];
    selectedAccount;
    accountInfo;
    financialAccounts = [];
    selectedFinancialAccount;
    vendorPaymentMethodsDD: any[] = [];
    selectedPmtMethod;
    allPaymentMethods: any[];
    tempDetail = {
        id: 0,
        accountName: "",
        channelId: "",
        accountId: "",
        vendorId: "",
        fromFinancialAccountName: "",
        fromFinancialAccountId: "",
        fromFinancialAccount: "",
        memo: "",
        checkNo: "",
        methodName: "",
        methodId: "",
        amount: 0,
        payTo: "",
        number: "",
        paymentDate: "",
        receivedPaymentId: "",
        txnType: "",
        txnTypeId: "",
        type: "",
        paymentMethods: [],
    };
    isEdit = false;

    depositDetailForm: FormGroup;
    depositForm: FormGroup;
    selectedPayments = [];
    currencySymbol = "";
    isVoided: boolean = false;

    // fraction digits
    fractionDigits: number = 0;
    statementMessage: string = "";

    pageIndex = 1;
    dataList = [];
    
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    isAllowPostingPeriod: boolean = false;
    makeDepositDetails: any;
    constructor(
        private confirmationService: ConfirmationService,
        public app: AppMainComponent,
        private purchaseService: PurchasesService,
        private salesOrderService: SalesOrderService,
        private fb: FormBuilder,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        public appMainService: AppMainService,
        private financeService: FinanceService,
        private currencyService: CurrencyService,
        private sharedChannelService: SharedChannelService,
        private financeUtilityService: FinanceUtilityService,
        private importService: ImportserialService,
        private utilityService: UtilityService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedFinance && changes.selectedFinance.currentValue) {
            this.selectedFinance = changes.selectedFinance.currentValue;
            this.loadFinancialAccounts();
            this.initData();
            this.getPaymentsList();
        }
        if (changes.depositId && changes.depositId.currentValue) {
            this.depositId = changes.depositId.currentValue;
            this.initData();
            this.getDepositDetailsById(this.depositId);
        }
        if (changes.type && changes.type.currentValue) {
            this.type = changes.type.currentValue;
        }
    }
    initData() {
        this.selectedPayments = [];
    }

    ngOnInit(): void {
        this.getFractionDigits();
        this.initDepositDetailForm();
        this.initDepositForm();
        this.getAccountChannels(AccountModuleId);
        this.getIsetting();

        this.currencySymbol = this.currencyService.currencySymbolValue;

        this.purchaseService.getVendorList().subscribe((vendor) => {
            this.purchaseService.getAllPOVendors().subscribe((vendor) => {
                this.allVendors = vendor;
                this.allVendorsDD = this.allVendors?.filter((vendor) => vendor.isActive == true);
            });
        });
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    initDepositDetailForm() {
        this.depositDetailForm = this.fb.group({
            id: [0],
            vendorId: [""],
            accountChannelId: [""],
            accountId: [""],
            toFinancialAccountId: [null, [Validators.required]],
            checkNo: ["", Validators.required],
            paymentMethodId: ["", Validators.required],
            amount: [""],
            memo: [""],
        });
    }

    initDepositForm() {
        this.depositForm = this.fb.group({
            id: [0],
            depositToBankFinancialAccountId: [""],
            depositDate: [this.app._showDateTimeWithZone(new Date()), Validators.required],
            memo: [""],
        });
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => { },
            });
    }

    prepareDepositDetails() {
        let depositDetails: IDepositDetail[] = [];
        this.selectedPayments.forEach((payment) => {
            let depositDetail: IDepositDetail = {
                id: payment?.id ? payment?.id : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                bankDepositId: this.depositId ? this.depositId : 0,
                accountListTypeId: this.payTo == "vendor" ? 2 : 1,
                accountId: payment?.accountId || 0,
                accountChannelId: payment?.channelId || payment?.accountChannelId,
                vendorId: payment?.vendorId || 0,
                toFinancialAccountId: payment?.fromFinancialAccountId || payment?.toFinancialAccountId,
                checkNo: payment?.checkNo || "",
                paymentMethodId: payment?.methodId || 0,
                amount: payment?.amount || 0,
                memo: payment?.memo || "",
                transactionTypeId: payment?.txnTypeId || payment?.transactionTypeId,
                transactionId: payment?.receivedPaymentId || payment?.transactionId,
                statusId: Status.Active,
            };
            depositDetails.push(depositDetail);
        });
        return depositDetails;
    }

    save() {
        if (!!this.statementMessage) { return; }
        if (this.selectedPayments?.length > 0) {
            let deposit: IDeposit = {
                id: 0 || this.depositId,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                depositToBankFinancialAccountId: this.depositForm.controls.depositToBankFinancialAccountId.value?.value?.id ?? 0,
                depositDate: this.app._saveDateTimeWithZone(this.depositForm.controls.depositDate.value),
                depositAmount: this.totalAmt,
                memo: this.depositForm.controls.memo.value,
                statusId: Status.Active,
                depositDetail: this.prepareDepositDetails(),
                organizationId: this.app.companyId,
                postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.type == 'Edit' ? this.makeDepositDetails?.postingDate : this.app._saveDateTimeWithZone(this.depositForm.controls.depositDate.value) ,
                postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.type == 'Edit' ? this.makeDepositDetails?.postingMonth : new Date(this.depositForm.controls.depositDate.value).getMonth() + 1,
                postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.type == 'Edit' ? this.makeDepositDetails?.postingYear : new Date(this.depositForm.controls.depositDate.value).getFullYear()
            };
            if (this.type !== 'Edit') {
                this.appMainService.isShowSpinner("savedeposit");
                this.financeService.saveDeposit(deposit)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (data) => {
                            this.appMainService.isHideSpinner("savedeposit");
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(Severity.Success),
                                detail: "Saved Successfully ...",
                            });
                            this.onClose("save");
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner("savedeposit");
                            this.messageService.add({
                                severity: Severity.Error,
                                summary: this.titlecasePipe.transform(Severity.Error),
                                detail: "Error occurred ...",
                            });
                        },
                    });
            } else {
                this.appMainService.isShowSpinner("updateDeposit");
                this.financeService.updateDeposit(deposit)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (data) => {
                            this.appMainService.isHideSpinner("updateDeposit");
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(Severity.Success),
                                detail: "Updated Successfully ...",
                            });
                            this.onClose("save");
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner("updateDeposit");
                            this.messageService.add({
                                severity: Severity.Error,
                                summary: this.titlecasePipe.transform(Severity.Error),
                                detail: "Error occurred ...",
                            });
                        },
                    });
            }


        }
    }
    next(){
        this.pageIndex = 2;
        this.dataList = this.selectedPayments;
    }

    addDetail() {
        this.isEdit = false;
        this.tempDetail = {
            id: 0,
            accountName: "",
            channelId: "",
            accountId: "",
            vendorId: "",
            fromFinancialAccountName: "",
            fromFinancialAccountId: "",
            fromFinancialAccount: "",
            memo: "",
            checkNo: "",
            methodName: "",
            methodId: "",
            amount: 0,
            payTo: "",
            number: "",
            paymentDate: "",
            receivedPaymentId: "",
            txnType: "",
            txnTypeId: "",
            type: "",
            paymentMethods: [],
        };
        this.selectedVendor = null;
        this.selectedAccount = null;
        this.selectedFinancialAccount = null;
        this.selectedPmtMethod = null;
        this.initDepositDetailForm();
        this.displayDetails = true;
    }

    editDetail(payment) {
        this.isEdit = true;
        this.tempDetail = JSON.parse(JSON.stringify(payment));
        this.initDepositDetailForm();
        this.payTo = this.tempDetail.payTo;
        let financialAccount = {
            label: payment.fromFinancialAccount.name,
            value: payment.fromFinancialAccount,
            children: payment.fromFinancialAccount.childAccounts,
        };

        this.depositDetailForm.patchValue({
            ...this.tempDetail,
            vendorId: this.allVendorsDD?.find((v) => v?.id == this.tempDetail?.vendorId),
            accountId: this.allAccountsDD?.find((a) => a.id == this.tempDetail.accountId),
            accountChannelId: this.accountChannels?.find((c) => c?.id == this.tempDetail?.channelId),
            toFinancialAccountId: financialAccount,
            paymentMethodId: payment.paymentMethods?.find((v) => v?.id == this.tempDetail?.methodId),
        });

        if (this.tempDetail.payTo == "vendor") {
            this.vendorPaymentMethodsDD = payment?.paymentMethods || [];
            this.selectedPmtMethod = this.vendorPaymentMethodsDD?.filter((v) => v.name == this.tempDetail.methodName)[0];
        } else if (this.tempDetail.payTo == "customer") {
            this.allPaymentMethods = payment?.paymentMethods || [];
            this.selectedPmtMethod = this.allPaymentMethods?.filter((v) => v.name == this.tempDetail.methodName)[0];
        }
        this.displayDetails = true;
    }

    saveDetail() {
        if (this.payTo == "vendor") {
            this.tempDetail.accountName = this.depositDetailForm.controls.vendorId?.value?.name || "";
            this.tempDetail.vendorId = this.depositDetailForm.controls.vendorId?.value?.id || 0;
            this.tempDetail.methodName = this.depositDetailForm.controls.paymentMethodId?.value?.paymentMethodMethod || "";
            this.tempDetail.methodId = this.depositDetailForm.controls.paymentMethodId?.value?.id || 0;
            this.tempDetail.paymentMethods = this.vendorPaymentMethodsDD;
        } else if (this.payTo == "customer") {
            this.tempDetail.accountName = this.depositDetailForm.controls.accountId?.value?.name || "";
            this.tempDetail.accountId = this.depositDetailForm.controls.accountId?.value?.id || 0;
            this.tempDetail.methodName = this.depositDetailForm.controls.paymentMethodId?.value?.name || "";
            this.tempDetail.methodId = this.depositDetailForm.controls.paymentMethodId?.value?.id || 0;
            this.tempDetail.paymentMethods = this.allPaymentMethods;
        }
        this.tempDetail.fromFinancialAccountName = this.depositDetailForm.controls.toFinancialAccountId?.value?.value?.name || "";
        this.tempDetail.fromFinancialAccountId = this.depositDetailForm.controls.toFinancialAccountId?.value?.value?.id || 0;
        this.tempDetail.fromFinancialAccount = this.depositDetailForm.controls.toFinancialAccountId?.value?.value || null;
        this.tempDetail.channelId = this.depositDetailForm.controls.accountChannelId?.value?.id || 0;
        this.tempDetail.payTo = this.payTo;
        this.tempDetail.memo = this.depositDetailForm.controls.memo?.value || "";
        this.tempDetail.checkNo = this.depositDetailForm.controls.checkNo?.value || "";
        this.tempDetail.amount = this.depositDetailForm.controls.amount?.value || 0;
        this.tempDetail.type = "MANUAL_PAYMENT";


        if (this.isEdit) {
            let arr = [];
            for (let s of this.paymentsTB) {
                if (s.id == this.tempDetail.id) {
                    s = this.tempDetail;
                }
                arr.push(s);
            }
            this.paymentsTB = JSON.parse(JSON.stringify(arr));
        } else {
            this.tempDetail.id = this.paymentsTB.length + 1;
            this.paymentsTB.push(this.tempDetail);
        }
        this.getSum();
        this.displayDetails = false;
        this.depositDetailForm.reset();
    }

    async getDepositDetailsById(id: number) {
        await this.loadFinancialAccounts();
        this.financeService.getDepositDetailsById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.makeDepositDetails = res;
                    this.paymentsTB = res?.depositDetail?.map((d) => ({ ...d, paymentDate: d?.createdDate, methodName: d?.paymentMethod, }));
                    this.isVoided = res?.isVoided
                    this.allPaymentsTb = this.paymentsTB;
                    this.depositForm.patchValue({
                        ...res,
                        depositDate: this.app._showDateTimeWithZone(res?.depositDate),
                        depositToBankFinancialAccountId: this.financeUtilityService.findRecursiveChildObjects(this.banks, res?.depositToBankFinancialAccountId)
                    });
                    this.currentPostingPeriodInfo = {
                        postingDate: this.makeDepositDetails?.postingDate,
                        postingMonth: this.makeDepositDetails?.postingMonth,
                        postingYear: this.makeDepositDetails?.postingYear
                    };
                    this.selectedPayments = [...this.paymentsTB];
                    this.getSum();
                    this.viewDepositForm();
                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }

    getSum() {
        this.totalAmt = 0;
        for (let s of this.selectedPayments) {
            this.totalAmt += s.amount;
        }
    }

    removeDetail(i) {
        this.paymentsTB.splice(i, 1);
        this.getSum();
    }

    getAccountChannels(id: number) {
        this.sharedChannelService.getChannels(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res: ChannelN[]) => {
                    this.accountChannels = res;
                    this.selectedChannel = this.accountChannels.filter((ac) => ac.isDefault == true)[0];
                    this.depositDetailForm?.controls?.accountChannelId?.setValue(this.selectedChannel);
                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }

    onChangeAccountChannel() {
        this.selectedAccount = null;
        this.depositDetailForm?.controls?.accountId?.setValue("");
    }

    filterAccount(event) {
        let query = event.query;
        const typeId = this.depositDetailForm?.controls?.accountChannelId?.value?.id || 0;
        query = event.query;
        this.salesOrderService.getAccountsByChannelId(typeId, query.toLowerCase())
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res: any) => {
                const filtered: any[] = [];
                if (res?.length > 0) {
                    this.allAccountsDD = res.filter((r) => r.statusId == Status.Active);
                }
            });
    }

    async selectAccount(c) {
        this.accountInfo = null;
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.id);

        //Active Payment Method
        let defaultMethods;
        this.allPaymentMethods = [];
        if (this.accountInfo?.accountPaymentMethods) {
            this.accountInfo?.accountPaymentMethods.forEach((e) => {
                this.allPaymentMethods.push(e.paymentMethod);
                if (e.isDefault) {
                    defaultMethods = e.paymentMethod;
                }
            });
        }
        this.selectedPmtMethod = defaultMethods;
        this.depositDetailForm.controls.paymentMethodId.setValue(this.selectedPmtMethod);
    }

    async loadFinancialAccounts(): Promise<void> {
        try {
            this.appMainService.isShowSpinner("loadaccounts");
            const accounts = await lastValueFrom(this.financeService.getAllFinancialAccounts(false).pipe(takeUntil(this.ngUnsubscribe$)));
            let acc = JSON.parse(JSON.stringify(accounts));
            this.financialAccounts = this.financeUtilityService.prepareFinancialAccountsData(acc);
            this.prepareBankAccountsData(this.financialAccounts);
            this.appMainService.isHideSpinner("loadaccounts");
        } catch (error) {
            this.appMainService.isHideSpinner("loadaccounts");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred ...",
            });
        }
    }

    getPaymentsList() {
        this.appMainService.isShowSpinner("loadpayments");
        this.financeService.getPaymentList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (payments) => {
                    this.paymentsTB = payments;
                    this.paymentsTB = [...this.allPaymentsTb, ...this.paymentsTB];
                    this.appMainService.isHideSpinner("loadpayments");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadpayments");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    prepareBankAccountsData(accounts) {
        let selectedBank;
        let assetData = accounts?.find((a) => a?.name?.toLowerCase() == "assets");
        let bankData = assetData?.children?.filter((b) => b?.subAccountType?.name?.toLowerCase() == "bank");
        this.banks = bankData || [];
        if (this.selectedFinance?.name?.toLowerCase() == "bank" && this.selectedFinance?.id == 0) {
            selectedBank = this.banks[0];
        } else {
            selectedBank = this.financeUtilityService.findRecursiveChildObjects(this.banks, this.selectedFinance?.id);
        }
        if (selectedBank) {
            this.depositForm.controls.depositToBankFinancialAccountId.setValue(selectedBank);
        }
    }

    voidOrDelete(isVoid: boolean) {
        if (!!this.statementMessage) {
            this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
        } else {
            this.confirmVoidDelete(isVoid);
        }
    }

    confirmVoidDelete(isVoid: boolean) {
        const isVoidStatus = isVoid ? 'Void' : 'Delete'
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this Deposit?`,
            header: `${isVoidStatus} Confirmation`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.financeService.bankEntriesVoidDelete(this.depositId, isVoid, 'RemoveDeposit', 'depositId').subscribe(resp => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: `${isVoidStatus}${isVoid ? 'ed' : 'd'} Successfully...`,
                    });
                    this.onClose("save");
                })
            },
        });
    }
    getSelectedVendorDetails() {
        this.appMainService.isShowSpinner("loadvendordetails");
        this.purchaseService.getVendorById(this.depositDetailForm.controls.vendorId.value?.id || 0)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res) => {
                    this.vendorDetails = res;
                    this.vendorPaymentMethodsDD = this.vendorDetails?.vendorPaymentMethod?.filter((method) => method.statusId == Status.Active);
                    this.selectedPmtMethod = res.vendorPaymentMethod?.filter((method) => method.isDefault == true)[0];
                    this.depositDetailForm.controls.paymentMethodId.setValue(this.selectedPmtMethod);
                    this.appMainService.isHideSpinner("loadvendordetails");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadvendordetails");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    onTableCheckboxToggle() {
        this.getSum();
    }

    viewToEditDeposit() {
        this.type = "Edit";
        this.depositHeader = "Edit Deposit";
        this.depositForm?.enable();
        this.getPaymentsList();
    }

    onClose(type): void {
        this.close.emit({ type: type });
    }

    viewDepositForm() {
        if (this.type === 'VIEW') {
            this.depositForm?.disable();
        } else {
            this.depositForm?.enable();
        }

    }

    isClosingStatementDate(event: string) {
        this.statementMessage = event;
    }
   onPostingInfoChange(postingInfo: IPostingPeriodDetails) {  
        this.updatedPostingPeriodInfo = postingInfo;
      }

    getIsetting() {
        this.appMainService.isShowSpinner("loadISettings");
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.appMainService.isHideSpinner("loadISettings");
    }
}
